import { getNewDateHourZero } from '../../screens/FinanceScreens/utils/getFineAndInterestValue'
import { formatDateToBarcode } from '../../utils/formatters'
import { GetStatement_listStatements_installmentsOverdue } from '../types/GetStatement'
import { getUrlAndBarcodeBankSlipIfExist } from './getUrlAndBarcodeBankSlipIfExist'
import { openPaymentSlip } from './openPaymentSlip'
import { registerBankSlip } from './registerBankSlip'

export interface Installment extends GetStatement_listStatements_installmentsOverdue {}

export const updateBankSlip = async (installment: Installment) => {
  const { receivableBillId, installmentId, dueDate: newDueDate } = installment
  const inputOpenPayment = {
    receivableBillId: receivableBillId.toString(),
    installmentId: installmentId.toString(),
    newDueDate,
  }
  try {
    const installmentUpdated = await getUrlAndBarcodeBankSlipIfExist(installment)
    const isExpiredBillet = verifyExpiredBillet(installmentUpdated)

    if (!isExpiredBillet) {
      return { installment: installmentUpdated, isGeneratingBarcode: false }
    }
    await openPaymentSlip(inputOpenPayment)
    await registerBankSlip({ receivableBillId: Number(receivableBillId), installmentId })
  } catch (error) {
    console.log(error, 'updateBankSlip')
    throw installment
  }
  return { installment, isGeneratingBarcode: true }
}

const verifyExpiredBillet = installmentUpdated => {
  if (installmentUpdated) {
    const dateBarCode = formatDateToBarcode(installmentUpdated?.digitableNumber)
    const expiredBillet = dateBarCode < getNewDateHourZero()
    return expiredBillet
  }
  return true
}
